import { render } from "./StaffMenu.vue?vue&type=template&id=67da0064"
import script from "./StaffMenu.vue?vue&type=script&lang=js"
export * from "./StaffMenu.vue?vue&type=script&lang=js"

import "./StaffMenu.vue?vue&type=style&index=0&id=67da0064&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__